<template>
  <v-menu left :close-on-click="true" v-model="showMenu">
    <template v-slot:activator="{ on }">
      <v-btn icon v-on="on">
        <v-icon>
          mdi-dots-vertical
        </v-icon>
      </v-btn>
    </template>

    <v-list>
      <v-dialog :value="showUpdateModal === item.id" width="500">
        <template v-slot:activator="{ on }">
          <v-list-item v-on="on" @click="showUpdateModal = item.id">
            <v-list-item-icon>
              <v-icon small>mdi-pencil</v-icon>
            </v-list-item-icon>
            <v-list-item-title>Redigera kommentar</v-list-item-title>
          </v-list-item>
        </template>
        <CrowdedTrainRegistrationEdit
          :registration="item"
          v-if="showUpdateModal === item.id"
          @confirm="confirm"
          @close="close"
        />
      </v-dialog>
    </v-list>
  </v-menu>
</template>

<script>
import CrowdedTrainRegistrationEdit from './CrowdedTrainRegistrationEdit'

export default {
  name: 'CrowdedTrainRegistrationActionMenu',

  components: {
    CrowdedTrainRegistrationEdit
  },

  props: {
    item: Object
  },

  data() {
    return {
      showMenu: false,
      showUpdateModal: null
    }
  },

  methods: {
    close() {
      this.showMenu = false
      this.showUpdateModal = null
    },

    confirm() {
      this.close()
      this.$emit('refetch')
    }
  }
}
</script>
